import { render, staticRenderFns } from "./RentTariffsView.vue?vue&type=template&id=a55d2870&scoped=true&lang=pug&"
import script from "./RentTariffsView.vue?vue&type=script&lang=js&"
export * from "./RentTariffsView.vue?vue&type=script&lang=js&"
import style0 from "./RentTariffsView.vue?vue&type=style&index=0&id=a55d2870&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a55d2870",
  null
  
)

export default component.exports